document.querySelectorAll('[data-f7-tabs]').forEach(function (tabbar) {
  var tabs = Array.prototype.slice.call(tabbar.querySelectorAll('.f7__tab'));

  function select(tab) {
    tabs.forEach(function (t) {
      var on = t === tab;
      t.setAttribute('aria-selected', on ? 'true' : 'false');
      t.tabIndex = on ? 0 : -1;
      var panel = document.getElementById(t.getAttribute('aria-controls'));
      if (panel) panel.classList.toggle('is-active', on);
    });
  }

  tabs.forEach(function (tab, index) {
    tab.addEventListener('click', function () {
      select(tab);
    });
    tab.addEventListener('keydown', function (event) {
      var next;
      if (event.key === 'ArrowRight') next = tabs[(index + 1) % tabs.length];
      else if (event.key === 'ArrowLeft') next = tabs[(index - 1 + tabs.length) % tabs.length];
      if (next) {
        event.preventDefault();
        select(next);
        next.focus();
      }
    });
  });
});
